<template>
  <div>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ oopt.transName }} - {{ $t('Наблюдатели') }}</h1>
      <div class="workroom-pg">
        <div class="bgw-pdg-20 observer-pg">
          <div class="add-npa-row">
            <ObserverAdd :ooptId="oopt.id">
              {{ $t('Добавить наблюдателя') }}
            </ObserverAdd>
          </div>
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td class="num-td">№</td>
                <td class="full-name-td">{{ $t('ФИО') }}</td>
                <td>{{ $t('Статус') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(observer, i) in oopt.ooptObservers" :key="observer.id">
                <td class="num-td">{{ ++i }}</td>
                <td class="full-name-td">
                    <ObserverAdd
                      :ooptId="oopt.id"
                      :observerId="observer.id"
                      :observerEdit="true"
                      :otherObserver="false"
                    >
                      {{ observer.transLastName }} {{ observer.transFirstName }} {{ observer.transSecondName }} <span class="edit-icon"></span>
                    </ObserverAdd>
                </td>
                <td>
                  <div class="status-org">
                    <ul>
                      <template v-if="observer.isActive === true">
                        <li class="active publish">
                          <a @click="publicObserver(observer.id)">{{ $t('Активен') }}</a>
                        </li>
                      </template>
                      <template v-else>
                        <li class="active">
                          <a @click="publicObserver(observer.id)">{{ $t('Не активен') }}</a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Observer from '@/model/observer'
import ObserverAdd from '@/components/oopt/ObserverAdd'

export default {
  components: { ObserverAdd },
  data: () => ({
    oopt: {},
    breadcrumbs: []
  }),
  watch: {
    $route: 'fetchData',
    page () {
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Observer.list(this.$route.params.id)
        .then((response) => {
          this.oopt = { ...response.data.oopt }
          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
            { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
            { text: this.oopt.transName, disabled: false, href: '/my-organization?id=' + this.oopt.id },
            { text: this.$i18n.t('Наблюдатели'), disabled: true }
          ]

          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    publicObserver (observerId) {
      Observer.setActive(observerId).then((response) => {
        this.fetchData()
      })
    }
  }
}
</script>
